import { vehicleGroupStatsSchema } from './vehicle-group-stats.schema';
import { z } from 'zod/v4';

export const customPlaceStatsSchema = z.object({
  customPlaceSetsTotalCount: z.number(),
  unUsedCustomPlaceSets: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      vehicleGroups: z.array(vehicleGroupStatsSchema),
      isDefault: z.boolean(),
    })
  ),
});

export type CustomPlaceStats = z.infer<typeof customPlaceStatsSchema>;
